import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_RESOURCE_LIBRARY_ASSET_ITEMS_QUERY = queryWithFallbackKey(
    gql`
        query getResourceLibraryAssetItemListing(
            $defaultLanguage: String!
            $filter: String
            $first: Int
            $after: Int
            $sortBy: [String]
            $sortOrder: [String]
        ) {
            getResourceLibraryItemListing(
                defaultLanguage: $defaultLanguage
                filter: $filter
                first: $first
                after: $after
                sortBy: $sortBy
                sortOrder: $sortOrder
            ) {
                edges {
                    node {
                        id
                        key
                        name
                        description
                        brand {
                            ... on object_Brand {
                                id
                            }
                        }
                        productGroup {
                            ... on object_ProductGroup {
                                id
                            }
                        }
                        productApplication {
                            ... on object_ProductApplicationSegment {
                                id
                            }
                            ... on object_ProductApplication {
                                id
                            }
                        }
                        resourceType {
                            ... on object_ResourceTypeGroup {
                                id
                            }
                            ... on object_ResourceType {
                                id
                            }
                        }
                        expirationDate
                        validFromDate
                        publicationDate
                        lastModificationDate
                        thumbnailUrl: thumbnail
                        assetLangEn: asset(language: "en") {
                            ... on asset {
                                fullpath
                                mimetype
                                type
                            }
                        }
                        assetLangDe: asset(language: "de") {
                            ... on asset {
                                fullpath
                                mimetype
                                type
                            }
                        }
                        assetLangJa: asset(language: "ja") {
                            ... on asset {
                                fullpath
                                mimetype
                                type
                            }
                        }
                        assetLangZhCn: asset(language: "zh") {
                            ... on asset {
                                fullpath
                                mimetype
                                type
                            }
                        }
                        assetLangZhTw: asset(language: "zh_Hant_TW") {
                            ... on asset {
                                fullpath
                                mimetype
                                type
                            }
                        }
                        navigationScope {
                            ... on object_NavigationNode {
                                id
                            }
                        }
                        exclusiveNavigationScope {
                            ... on object_NavigationNode {
                                id
                            }
                        }
                    }
                }
            }
        }
    `,
    'GET_RESOURCE_LIBRARY_ASSET_ITEMS_QUERY'
);

export function getResourceLibraryAssetItemsQueryVariables(
    localeCode: LocaleCode,
    filter?: string,
    first?: number,
    after?: number,
    sortBy?: string[],
    sortOrder?: string[]
) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
        filter: filter ?? null,
        first: first ?? null,
        after: after ?? null,
        sortBy: sortBy ?? null,
        sortOrder: sortOrder ?? null,
    };
}
